module.exports = __webpack_public_path__ + "Poppins-SemiBoldItalic.659f041be18f2568d8a9.woff2";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Poppins-SemiBoldItalic.woff2
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Poppins-SemiBoldItalic.woff2
// module chunks = styles